const DEFAULT_CHARACTER_PLATFORM_API_URL = "http://localhost:8000"

function getPlatformEnvSnapshot() {
  return {
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    NEXT_PUBLIC_SUPABASE_AUTH_URL: process.env.NEXT_PUBLIC_SUPABASE_AUTH_URL,
    NEXT_PUBLIC_SUPABASE_AUTH_ANON_KEY:
      process.env.NEXT_PUBLIC_SUPABASE_AUTH_ANON_KEY,
    NEXT_PUBLIC_SUPABASE_DATA_URL: process.env.NEXT_PUBLIC_SUPABASE_DATA_URL,
    NEXT_PUBLIC_SUPABASE_DATA_ANON_KEY:
      process.env.NEXT_PUBLIC_SUPABASE_DATA_ANON_KEY,
    NEXT_PUBLIC_CHARACTER_PLATFORM_API_URL:
      process.env.NEXT_PUBLIC_CHARACTER_PLATFORM_API_URL,
    NEXT_PUBLIC_CHARACTER_PLATFORM_BACKEND_URL:
      process.env.NEXT_PUBLIC_CHARACTER_PLATFORM_BACKEND_URL,
  }
}

function firstNonEmpty(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim().length > 0) {
      return value
    }
  }

  return ""
}

function resolveSupabaseConfigFromEnv(env, sources) {
  for (const source of sources) {
    const url = firstNonEmpty(env[source.url])
    const anonKey = firstNonEmpty(env[source.anonKey])

    if (url || anonKey) {
      if (url && anonKey) {
        return { url, anonKey }
      }

      throw new Error(
        `Missing required Supabase ${source.label} env vars: ${source.url} and ${source.anonKey} must both be set.`
      )
    }
  }

  return null
}

export function getSupabaseAuthConfigFromEnv(env = getPlatformEnvSnapshot()) {
  const config = resolveSupabaseConfigFromEnv(env, [
    {
      label: "public",
      url: "NEXT_PUBLIC_SUPABASE_URL",
      anonKey: "NEXT_PUBLIC_SUPABASE_ANON_KEY",
    },
    {
      label: "legacy auth",
      url: "NEXT_PUBLIC_SUPABASE_AUTH_URL",
      anonKey: "NEXT_PUBLIC_SUPABASE_AUTH_ANON_KEY",
    },
  ])

  if (!config) {
    throw new Error(
      "Missing required Supabase auth env vars. Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY, or NEXT_PUBLIC_SUPABASE_AUTH_URL and NEXT_PUBLIC_SUPABASE_AUTH_ANON_KEY for legacy compat deployments."
    )
  }

  return config
}

export function getSupabaseDataConfigFromEnv(env = getPlatformEnvSnapshot()) {
  const config = resolveSupabaseConfigFromEnv(env, [
    {
      label: "data",
      url: "NEXT_PUBLIC_SUPABASE_DATA_URL",
      anonKey: "NEXT_PUBLIC_SUPABASE_DATA_ANON_KEY",
    },
    {
      label: "public",
      url: "NEXT_PUBLIC_SUPABASE_URL",
      anonKey: "NEXT_PUBLIC_SUPABASE_ANON_KEY",
    },
  ])

  if (!config) {
    throw new Error(
      "Missing required Supabase data env vars. Set NEXT_PUBLIC_SUPABASE_DATA_URL and NEXT_PUBLIC_SUPABASE_DATA_ANON_KEY, or NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY for merged-project deployments."
    )
  }

  return config
}

export function getCharacterPlatformApiUrlFromEnv(
  env = getPlatformEnvSnapshot()
) {
  return (
    env.NEXT_PUBLIC_CHARACTER_PLATFORM_API_URL ??
    env.NEXT_PUBLIC_CHARACTER_PLATFORM_BACKEND_URL ??
    DEFAULT_CHARACTER_PLATFORM_API_URL
  )
}
